"use client";

import { BioProcess, SeedCollection, SeedConservationProcess } from "@/app/data/programs/Process";
import ServiceProcessCard from "@/app/components/frontend/cards/ServiceProcessCard";
import { seedConservationData } from "@/app/data/AccordionData";
import { BioServices, SeedConservationServices } from "@/app/data/programs/Services";
import { BioStats, ConservationStats } from "@/app/data/programs/Stats";
import StatsCard from "@/app/components/frontend/cards/StatsCard";
import ProgramCard from "@/app/components/frontend/cards/ProgramCard";
import Link from "next/link";
import SeedCollectionCard from "@/app/components/frontend/cards/SeedCollectionCard";


export default function SeedConservation() {
    return (
        <div className="flex flex-col items-end justify-start w-full bg-gray-200">

            {/* TOP SECTION */}
            <div className="flex items-end justify-center w-full pb-20 sm:pb-32 lg:pb-40 relative"
            style={{backgroundImage:"url('/images/bio.jpeg')", backgroundSize:"cover", backgroundPosition:"center center", backgroundRepeat:"no-repeat"}}>
                <div className="bg-primary/60 inset-0 absolute"/>
                <div className="flex flex-col gap-3 sm:gap-4 lg:gap-5 px-6 sm:px-10 lg:pl-30 pt-40 items-center justify-center z-10 text-white">
                    <h5 className="text-base sm:text-lg lg:text-xl text-white bg-accent px-4 py-1 rounded-full">Our programs</h5>
                    <h1 className="text-3xl sm:text-4xl lg:text-[56px] leading-tight sm:leading-12 lg:leading-14 font-bold font-lora text-center">
                        BioFertilizers and Biopesticides
                    </h1>
                    <p className="text-base sm:text-lg lg:text-xl text-center w-full sm:w-[80%] lg:w-[60%]">
                        At Eden Indigenous Seed Farms, we train communities to make, apply, and commercialize biofertilizers and biopesticides. This program reduces reliance on chemical inputs, improves soil health, protects crops naturally, and creates new income opportunities through local production and sales.
                    </p>
                </div>
            </div>

            {/* SECTION 2 */}
            <div className="flex flex-col lg:flex-row w-full justify-start items-start gap-8 sm:gap-12 lg:gap-25 bg-gray-200 text-black pt-10 sm:pt-15 lg:pt-20 pb-8 sm:pb-10 px-6 sm:px-10 lg:px-20">
                <div className="flex flex-col gap-4 sm:gap-5 w-full lg:w-1/2 items-start justify-start">
                    <h4 className="text-base sm:text-lg px-4 sm:px-6 rounded-full leading-8 sm:leading-10 font-lora font-bold text-primary bg-accent/30">
                        Why it matters.
                    </h4>  
                    <p className="text-base sm:text-lg text-justify pt-2">
                        Healthy soils and resilient crops are the foundation of food security. Biofertilizers enrich the soil with beneficial microorganisms, while biopesticides provide natural protection against pests and diseases. Together, they:
                    </p>
                    <ul className="md:pl-10 md:space-y-3 list-disc list-inside">
                        <li>Restore soil fertility and biodiversity</li>
                        <li>Reduce chemical residues in food</li>
                        <li>Lower farming costs for smallholders</li>
                        <li>Create eco-friendly products for local markets</li>
                    </ul>
                </div>
                <div className="flex flex-col w-full lg:w-1/2 text-lg items-start justify-start h-[300px] sm:h-[350px] lg:h-[400px]"
                style={{backgroundImage:"url('/images/biofertilizers-main.jpeg')", backgroundSize:"cover", backgroundPosition:"center center", backgroundRepeat:"no-repeat"}}>
                    
                </div>
            </div>

            {/* SECTION 3 */}
            <div className="flex flex-col w-full justify-start items-start py-10 sm:py-15 lg:py-20">
                <div className="flex flex-col items-center justify-center w-full px-6 sm:px-10">
                    <h3 className="text-2xl sm:text-3xl lg:text-[40px] font-lora font-semibold leading-tight sm:leading-12 lg:leading-14 text-center">
                        Our Services
                    </h3>
                    <p className="text-base sm:text-lg pt-2 w-full sm:w-[70%] lg:w-[50%] text-center">
                        We provide hands-on training and support to farmer groups and communities:
                    </p>
                </div>
                <div className="flex flex-col sm:flex-row flex-wrap lg:flex-nowrap items-center justify-center w-full gap-4 sm:gap-5 py-8 sm:py-10 lg:py-14 px-6 sm:px-10 lg:px-0">
                    {BioServices.map((program, index) => (
                        <ProgramCard program={program} key={index} index={index} />
                    ))}
                </div>
            </div>

            {/* SECTION - OUR IMPACT ATTAINED */}
            <div className="flex flex-col lg:flex-row justify-start items-stretch w-full bg-primary">
                <div className="flex w-full lg:w-1/2 items-start justify-start h-[300px] sm:h-[400px] lg:h-auto">
                    <div className="flex w-full h-full" style={{backgroundImage: "url('/images/biopesticides.jpeg')", backgroundSize:"cover", backgroundRepeat:"no-repeat", backgroundPosition:"center center"}}
                    ></div>
                </div>
                <div className="flex w-full lg:w-1/2 items-start justify-start">
                    <div className="flex flex-col w-full items-start justify-start px-6 sm:px-10 lg:pl-20 py-10 sm:py-12 lg:py-15 text-white">
                        <h4 className="bg-accent/40 px-4 sm:px-6 py-1 rounded-full text-base sm:text-lg">Our impact</h4>
                        <div className="flex flex-col mt-6 sm:mt-8 gap-4 sm:gap-5 lg:gap-6 w-full">
                            {BioStats.map((stat, index) => (
                                <StatsCard stat={stat} key={index} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* SECTION CALL TO ACTION */}
            <div className="flex flex-col w-full justify-start items-center gap-3 sm:gap-4 py-12 sm:py-16 lg:py-20 text-white bg-secondary px-6 sm:px-10">
                <h2 className="text-2xl sm:text-3xl lg:text-[42px] font-lora font-bold text-center">
                    Be part of our movement.
                </h2>
                <p className="text-base sm:text-lg text-center w-full sm:w-[70%] lg:w-[42%]">
                    Join our mission to preserve Kenya&apos;s agricultural heritage and support sustainable farming practices for future generations.
                </p>
                <div className="flex flex-col sm:flex-row w-full items-center justify-center mt-4 gap-4 sm:gap-5">
                    <Link href="" className="bg-accent border-2 border-accent hover:bg-yellow-500 px-5 text-black rounded-md py-3 sm:py-4 w-full sm:w-auto text-center transition-colors">
                        Join our community
                    </Link>
                    <Link href="" className="border-2 border-white text-white hover:bg-accent hover:border-accent rounded-md px-5 py-3 sm:py-4 w-full sm:w-auto text-center transition-colors">
                        Partner with us
                    </Link>
                </div>
            </div>
        </div>  
    );
}